import { render, staticRenderFns } from "./FormResetPassword.vue?vue&type=template&id=47aac1e9&"
import script from "./FormResetPassword.vue?vue&type=script&lang=js&"
export * from "./FormResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./FormResetPassword.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports